export default __webpack_public_path__ + "static/media/schoolImage.a01e4bd0.jpg";